<script lang="ts">
  import flywheel from "@images/flywheel/flywheel-image.png"
  import { Repeat2, Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
</script>

<div
  class="mt-8 mx-auto grid max-w-2xl grid-cols-1 gap-x-2 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-2"
>
  <div class="lg:pr-8">
    <div class="lg:max-w-xl bg-white shadow rounded">
      <div class="py-4 px-6">
        <p
          class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl flex justify-start items-center"
        >
          <Lock class="size-7 text-red-800 mr-2" />
          Flywheel
        </p>
        <p class="mt-6 text-lg/8 text-gray-700">
          The Flywheel is not available at your current Free Subscription level.
          Please upgrade to the Standard Subscription to enable access to the
          Flywheel module and it's features.
        </p>
        <dl
          class="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none"
        >
          <div class="relative pl-9">
            <dt class="inline font-semibold text-gray-900">
              <Repeat2 class="size-6 absolute top-1 left-1 text-blue-600" />
              Create Flywheel
            </dt>
            <dd class="inline">
              The Flywheel is a powerful tool to help you and your team
              visualize your marketing and lead generation efforts. Our tool
              allow you to create a custom Flywheel that fits your business
              model.
            </dd>
          </div>
        </dl>
      </div>
      <div class="py-4 px-8 mt-6 flex justify-end border-t border-gray-200">
        <a
          href={`/plans/${appStore.plan.id}/admin`}
          class="rounded-md bg-green-600 px-3.5 py-2.5 text-base font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
          >Upgrade Now</a
        >
      </div>
    </div>
  </div>
  <img
    width="1400"
    height="1425"
    src={flywheel}
    alt="Product screenshot"
    class="w-2xl max-w-none ring-gray-200/10 sm:w-138 md:-ml-4 lg:-ml-0 mx-auto"
  />
</div>
